import i18n, { TFunction } from 'i18next';
import {
    App,
    NormalizedServerFeature,
    Screenshot,
    ServerFeature,
    ServerFeatureConfig,
} from 'models/app';
import { truncateString } from './helpers';

// Returning readable format after removing underscore and exclamation
export const readableFormat = (str?: string,maxSize?:number): string => {
  if (str === undefined) {
    return '';
  }
  const arr = str.split(/\s|_/);
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i].substr(0, 1).toUpperCase() + (arr[i].length > 1 ? arr[i].substr(1).toLowerCase() : ' ');
  }

  if (!!maxSize) {
	return truncateString(arr.join(' ').replace(/!$/, ''), maxSize);
  }
  
  return arr.join(' ').replace(/!$/, '');
};

export const prettyCategories = (categoryName: string, t : TFunction): string => {
  return (
    {
      ACCOUNTING_TAX: t('categories.ACCOUNTING_TAX'),
      BOOKING_RESERVATIONS: t('categories.BOOKING_RESERVATIONS'),
      CASH_MANAGEMENT: t('categories.CASH_MANAGEMENT'),
      ECOMMERCE: t('categories.ECOMMERCE'),
      EMPLOYEE_MANAGEMENT: t('categories.EMPLOYEE_MANAGEMENT'),
      FINANCIAL_SERVICES: t('categories.FINANCIAL_SERVICES'),
      FORM_BUILDING_SIGNATURE_CAPTURE: t('categories.FORM_BUILDING_SIGNATURE_CAPTURE'),
      FUNDRAISING: t('categories.FUNDRAISING'),
      GIFT_CARDS: t('categories.GIFT_CARDS'),
      ITEMS_INVENTORY: t('categories.ITEMS_INVENTORY'),
      INVOICING_SERVICES: t('categories.INVOICING_SERVICES'),
      KITCHEN_OPERATIONS: t('categories.KITCHEN_OPERATIONS'),
      MARKETING: t('categories.MARKETING'),
      MEMBERSHIPS: t('categories.MEMBERSHIPS'),
      ORDERS_DELIVERY: t('categories.ORDERS_DELIVERY'),
      REPORTING_ANALYTICS: t('categories.REPORTING_ANALYTICS'),
      SECURITY_FRAUD: t('categories.SECURITY_FRAUD'),
      TICKETING_EVENT_MANAGEMENT: t('categories.TICKETING_EVENT_MANAGEMENT'),
    }[categoryName] || readableFormat(categoryName)
  );
};

export const reconcileI18LanguageWithServerResponseLanguage = (language: string = i18n.language): string => {
  return language.replace(/[^A-Z0-9]+/gi, '_');
};

export const detectLocale = (app: App) => {
  const currentLanguage = reconcileI18LanguageWithServerResponseLanguage();
  return app.locales?.elements.find((internalApp: { locale: string }) => internalApp.locale === currentLanguage);
};

export const detectScreenShotLocale = (app: App) => {
  const currentLanguage = reconcileI18LanguageWithServerResponseLanguage();
  const combinedScreenShots: Screenshot[] =[];
  app.screenshots?.elements.map(media=>(combinedScreenShots.push(media)));
  const detectLocaleScreenShot = combinedScreenShots.filter(el=>el.locale === currentLanguage);

  if(detectLocaleScreenShot.length >0){
    return  combinedScreenShots.filter(el=>el.locale === currentLanguage)
  }
  else return combinedScreenShots.filter(el=>el.locale === 'en_US')
};

export const groupBy = <T, K extends string>(list: T[], getKey: (item: T) => K) =>
    list.reduce((previous, currentItem) => {
        const group = getKey(currentItem);
        if (!previous[group]) previous[group] = [];
        previous[group].push(currentItem);
        return previous;
    }, {} as Record<K, T[]>);

export const parseAndNormalizeServerFeature = (serverFeature: ServerFeature): NormalizedServerFeature => {
    let { config, enabled, name, id } = serverFeature,
      parsedConfig: ServerFeatureConfig = {};

    if(typeof config === 'string') {
        try {
            parsedConfig = JSON.parse(config);
            if (!parsedConfig) parsedConfig = {};
        }catch(e) {
            parsedConfig = {};
        }
    }else if (typeof config === 'undefined'){
        parsedConfig = {};
    }else{
        parsedConfig = config;
    }

    const { blacklistedApps, blacklistedDevelopers, ...rest } = parsedConfig;
    let normalizedData: NormalizedServerFeature = {
        name,
        id,
        enabled,
        blacklistedApps: {},
        blacklistedDevelopers: {},
        ...rest
    };

    if(parsedConfig.blacklistedApps && parsedConfig.blacklistedApps.length) {
        parsedConfig.blacklistedApps.forEach((blackListedAppId: Uuid) => {
            normalizedData.blacklistedApps[blackListedAppId] = true;
        })
    }
    if(parsedConfig.blacklistedDevelopers && parsedConfig.blacklistedDevelopers.length) {
        parsedConfig.blacklistedDevelopers.forEach((blackListedDeveloperId: Uuid) => {
            normalizedData.blacklistedDevelopers[blackListedDeveloperId] = true;
        })
    }
    return normalizedData
}

export const convertToSentenceCase = (str: string): string => {
    return str[0].toUpperCase() + str.slice(1).toLocaleLowerCase();
  };
  